<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            label="대분류"
            name="categoryFst"
            v-model="searchParam.categoryFst">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            label="중분류"
            name="categorySnd"
            v-model="searchParam.categorySnd">
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="JOB_CATEGORY_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            label="대상직군"
            name="jobCategoryCd"
            v-model="searchParam.jobCategoryCd"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="직군별 위험성평가 항목"
      tableId="riskItem"
      :merge="grid.merge"
      :columns="grid.columns"
      :data="grid.data"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <!-- 추가 -->
          <c-btn
            v-if="editable"
            :showLoading="false"
            label="LBLADD"
            icon="add"
            @btnClicked="add"
          />
          <!-- 저장 -->
          <c-btn
            v-if="editable"
            :isSubmit="isSave"
            :url="saveUrl"
            :param="grid.data"
            mappingType="PUT"
            label="LBLSAVE"
            icon="save"
            @beforeAction="save"
            @btnCallback="saveCallback"
          />
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "risk-item",
  data() {
    return {
      searchParam: {
        categoryFst: "",
        categorySnd: "",
        useFlag: "Y",
        jobCategoryCd: 'OFFICE',
      },
      grid: {
        merge: [
          { index: 0, colName: "categoryFst" },
          { index: 1, colName: "categorySnd" },
        ],
        columns: [
          {
            name: "categoryFst",
            field: "categoryFst",
            label: "대분류",
            align: "left",
            style: "width:200px",
            sortable: true,
            type: "text",
          },
          {
            name: "categorySnd",
            field: "categorySnd",
            label: "중분류",
            align: "left",
            style: "width:200px",
            sortable: true,
            type: "text",
          },
          {
            name: "categoryTrd",
            field: "categoryTrd",
            label: "소분류",
            align: "left",
            // style: "width:300px",
            sortable: true,
            required: true,
            type: "text",
          },
          {
            name: "sortOrder",
            field: "sortOrder",
            label: "LBLSORTORDER",
            align: "center",
            style: "width:80px",
            sortable: false,
            type: "number",
          },
          {
            name: "useFlag",
            field: "useFlag",
            label: "사용여부",
            align: "center",
            style: "width:80px",
            sortable: true,
            type: "check",
            true: "Y",
            false: "N",
          },
          {
            name: "jobCategoryCd",
            field: "jobCategoryCd",
            label: "대상직군",
            align: "center",
            style: "width:100px",
            sortable: false,
            type: "select",
            codeGroupCd: "JOB_CATEGORY_CD",
          },
        ],
        data: [],
      },
      useFlagItems: [
        { code: "Y", codeName: "사용" },
        { code: "N", codeName: "미사용" },
      ],
      editable: true,
      isSave: false,
      listUrl: "",
      saveUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.riskItem.list.url;
      this.saveUrl = transactionConfig.ram.riskItem.save.url;
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    add() {
      if (!this.grid.data) this.grid.data = [];
      this.grid.data.push({
        riskOfficeItemId: "", // 기준항목 일련번호
        sortOrder: this.grid.data.length + 1, // 정렬순서
        useFlag: "Y", // 사용여부
        regUserId: this.$store.getters.user.userId, // 등록자 ID
        editFlag: "C",
      });
    },
    save() {
      if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
        let saveData = this.$_.filter(this.grid.data, (item) => {
          return item.editFlag === "C" || item.editFlag === "U";
        });
        if (!saveData || saveData.length === 0) {
          window.getApp.$emit("ALERT", {
            title: "LBLGUIDE", // 안내
            message: "MSG0000408", // 저장할 데이터가 없습니다.
            type: "warning", // success / info / warning / error
          });
          return;
        }
        this.$_.forEach(saveData, (item) => {
          if (item.editFlag === "U") {
            item.chgUserId = this.$store.getters.user.userId;
          }
        });
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSGSAVE", // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave = !this.isSave;
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    saveCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.getList();
    },
  },
};
</script>
